import { ConfirmDeleteModal } from '@app/components/ConfirmDeleteModal';
import { GenericModal, useModal } from '@app/components/GenericModal';
import { useAuth } from '@app/hooks/useAuth';
import {
  ContentData,
  deleteBusinessLibrary,
} from '@app/services/otherContentService';
import { Delete, Edit } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { Form } from './Form';

interface Props {
  data: ContentData;
}

export function ListItemActions({ data }: Props) {
  const {
    isOpen: isEditModalOpen,
    openModal: openEditModal,
    closeModal: closeEditModal,
  } = useModal();

  const {
    isOpen: isDeleteModalOpen,
    openModal: openDeleteModal,
    closeModal: closeDeleteModal,
  } = useModal();

  const { tokenData } = useAuth();
  const token = tokenData?.token || '';

  return (
    <>
      <Stack direction="row" justifyContent="end" spacing={1} py={1}>
        <IconButton onClick={openEditModal}>
          <Edit color="info" />
        </IconButton>

        <IconButton onClick={openDeleteModal}>
          <Delete color="error" />
        </IconButton>
      </Stack>

      <GenericModal
        title="Edit Event"
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        useOnlyCloseButton
      >
        <Form
          onClose={closeEditModal}
          token={token}
          id={data.id}
          defaultValues={data}
        />
      </GenericModal>

      <ConfirmDeleteModal
        open={isDeleteModalOpen}
        onClose={closeDeleteModal}
        text={data.url}
        deleteFn={() => deleteBusinessLibrary({ token, id: data.id })}
        queryKey="business-library"
      />
    </>
  );
}
